/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/anchor-is-valid */
import axios from 'axios'
import i18next from 'i18next'
import React, {Fragment, useCallback, useEffect, useState} from 'react'
import {Spinner} from 'react-bootstrap'
import Button from 'react-bootstrap/Button'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import Row from 'react-bootstrap/Row'
import {useTranslation} from 'react-i18next'
import {useDispatch, useSelector} from 'react-redux'
import {useNavigate} from 'react-router-dom'
import swal from 'sweetalert'
import {KTSVG} from '../../../_metronic/helpers'
import {setGetNotif, setNotifFindoc} from '../../../_metronic/redux/content'
import {create, deleteFile, getFile, notifFindoc} from '../../../api/modules/file'
import {getAccesses, sentToSAP} from '../../../api/modules/findoc'
import {getFindocTypes, getIncoterm, getSalesArea, getSalesAreaLetter} from '../../../api/modules/getdatalist'
import {useAppDispatch, useAppSelector} from '../../../redux/hooks'
import {
  financialDocsSelector,
  setFinancialDocuments,
  setNumberUrl,
  resetFilter,
} from '../../../redux/slices/financialDocsSlices'
import Pagination from '../component/Pagination'
import {ButtonGroups} from './ButtonGroups'
import RowFilter from './RowFilter'
import RowHead from './RowHead'
import {PopoverText} from '../../../components/Popover/Popover'
import {headers, searchFindoc} from '../../../services/fetcher'
import {objToParams} from '../../../utils/objToParams'
import * as TableUI from '../../../components/Table/Table'
import {useRowTable} from '../../../hooks/useRowTable'
import {StyledCard} from '../../../components/StyledCard'
import {appSelector} from '../../../redux/slices/appSlices'
import {HakAkses} from '../../../components/mikro/getHakAkses'
import {authSelector} from 'src/redux/slices/authSlices'
import dateformat from 'src/utils/dateformat'
import {CheckSameIDAttachment} from 'src/components/mikro/CheckSameIDAttachment'
import {setIsFetchData} from 'src/redux/slices/filterSlices'
import Skeleton from 'react-loading-skeleton'
import { InputFile } from 'src/app/components/InputFile'
import { handleDownloadAttachment } from 'src/app/helpers/file'

type Props = {
  className: string
}

const TableFinancial: React.FC<Props> = ({className}) => {
  const {roleId} = useAppSelector(authSelector)
  const {filter} = useAppSelector(financialDocsSelector)
  const [tooltip, setTooltip] = useState('Open')
  const dispatch = useAppDispatch()
  const hakAkses = HakAkses()

  const {RowEmptyData, RowErrorFetch, RowLoader} = useRowTable({
    colSpan: 25,
    onReloadTable: () => handleReload(),
  })

  const handleOpen = async (e: any) => {
    const icon = e.target
    if (icon.classList.contains('iconArow')) {
      icon?.classList.remove('iconArow')
      icon?.classList.add('iconArowOpen')
      setTooltip('Close')
    } else {
      icon?.classList.remove('iconArowOpen')
      icon?.classList.add('iconArow')
      setTooltip('Open')
    }
    const target = e.currentTarget.getAttribute('data-target')
    const fold = document.getElementById(target)
    fold?.classList.toggle('fold-open')
  }

  const notifFindo = useSelector((state: any) => state.notif.notifFindoc)
  const notif = useSelector((state: any) => state.notif.getNotif)
  const [badge, setBadge] = useState()

  const [accesses, setAccesses] = useState<any>()

  const handleNotif = async (data: any) => {
    if (data.status != 5) return

    const id = data.id
    const user_id = data.customer_id
    const status = data.status
    setBadge(data.has_notif)
    // const notif = {
    //   id : data.id,
    //   user_id: data.customer_id,
    //   status: data.status
    // }
    // console.log(notif);

    await notifFindoc(id, user_id, status).then((res) => {
      const data = res.data.data
      dispath(setNotifFindoc(notifFindo - data))
    })
  }

  const dispath = useDispatch()
  const {t} = useTranslation()
  const [btnLoading, setBtnLoading] = useState(false)

  const [findoc, setFindoc] = useState<any[]>([])
  const [loading, setLoading] = useState(true)
  const [numberURL, setNumberURL] = useState([])
  const [showUpload, setShowUpload] = useState(false)
  const [files, setFiles] = useState({file: null})
  const [allFile, setAllFiles] = useState<any[]>([])
  const [namaFile, setNamaFile] = useState('')
  const [description, setDescription] = useState('')
  const [isPrivate, setIsPrivate] = useState(false)
  const [dataType, setDataType] = useState('')
  const [showReason, setShowReason] = useState(false)
  const [reason, setReason] = useState('')
  const [status, setStatus] = useState(0)
  const [isError, setIsError] = useState(false)
  const [isLoadingModal, setIsLoadingModal] = useState(false)
  const [dataProdusen, setDataProdusen] = useState<any[]>([])
  const [incoterm, setIncoterm] = useState<any[]>([])
  const [findocTypes, setFindocTypes] = useState<any[]>([])

  const navigate = useNavigate()

  const getAllData = async () => {
    await getSalesArea(localStorage.getItem('cust-code')).then((res) => {
      // console.log(res.data.data)
      setDataProdusen(res.data.data)
    })
    await getIncoterm().then((res) => {
      // console.log(res.data.data)
      setIncoterm(res.data.data)
    })
    await getFindocTypes().then((res) => {
      setFindocTypes(res.data.data)
    })
  }

  const [idItem, setIDItem] = useState('')

  const clearInputUpload = () => {
    const input1 = document.getElementById('uploadketerangan') as HTMLInputElement
    input1.value = ''
    const input2 = document.getElementById('upload') as HTMLInputElement
    input2.value = ''
    const inputPrivate = document.getElementById('isPrivate') as HTMLInputElement
    inputPrivate.checked = false
    // const input3 = document.getElementById("uploadnama") as HTMLInputElement
    // input3.value = ''
    // const input4 = document.getElementById("uploadjenis") as HTMLInputElement
    // input4.value = t('Select file type')
  }

  const removeFileState = () => {
    setFiles({file: null})
    setNamaFile('')
    setDescription('')
    setDataType('')
    setIsPrivate(false)
  }

  const deleteAttachment = async (id: any) => {
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Yes')}`],
      dangerMode: true,
    }).then(async (del) => {
      if (del) {
        await deleteFile(id)
          .then(() => {
            swal({
              closeOnClickOutside: false,
              title: t('Dokumen Berhasil Dihapus'),
              icon: 'success',
            })
            ambilAttachment(idItem)
          })
          .catch((error) => {
            swal({
              title: error.response.data,
              icon: 'error',
            })
          })
      }
    })
  }

  const resendToSAP = async (id: any) => {
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Cancel')}`, `${t('Yes')}`],
      dangerMode: true,
    }).then(async (confirm: any) => {
      if (confirm) {
        setLoading(true)
        await sentToSAP(id)
          .then((res) => {
            swal({
              title: `${t('Already Sent to SAP')}`,
              icon: 'success',
            }).then(() => onFetchFindoc())
          })
          .catch((err: any) => {
            swal({
              title: `${t(err.response.data.message)}`,
              icon: 'error',
            })
          })
          .finally(() => setLoading(false))
      }
    })
  }

  const dateFormatting = (date: any) => {
    let today = new Date(date)
    let dd = String(today.getDate()).padStart(2, '0')
    let mm = String(today.getMonth() + 1).padStart(2, '0') //January is 0!
    let yyyy = today.getFullYear()
    return dd + '-' + mm + '-' + yyyy
  }

  const handleUpload = async (id: any) => {
    setBtnLoading(true)
    let file = files.file
    let formdata = new FormData()
    formdata.append('file_r', file!)
    formdata.append('name', namaFile!)
    formdata.append('description', description!)
    formdata.append('attach_parent', id!)
    formdata.append('file_type', dataType)
    formdata.append('private', isPrivate.toString())
    formdata.append('credentials', localStorage.getItem('credential')!)
    // console.log(formdata)
    await create('findoc', formdata)
      .then((res) => {
        if (!res.data.error) {
          ambilAttachment(id)
          swal({
            title: `${t('document uploaded successfully')}`,
            icon: 'success',
          })
          removeFileState()
          clearInputUpload()
        } else {
          swal({
            title: t(res.data.message),
            icon: 'error',
          })
        }
      })
      .catch(function (error) {
        if (error) {
          swal({
            title: t(error.response.data.message),
            icon: 'error',
          })
        }
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  const ambilAttachment = async (id: any) => {
    const res = await getFile('findoc', id, localStorage.getItem('credential')!)
    handleShowAttachment(res.data.data)
    setIsLoadingModal(false)
  }

  const handleShowAttachment = (data: any) => {
    setAllFiles(data)
  }

  const [roleUser, setRoleUser] = useState('')
  const [salesOrg, setSalesOrg] = useState<any>()

  useEffect(() => {
    const role = () => {
      const role: any = localStorage.getItem('role-flag')
      setRoleUser(role)
    }

    const getAccessMenu = async () => {
      setLoading(true)
      const res = await getAccesses(roleId)
      setAccesses(res.data.data)
    }

    const getSalesOrg = async () => {
      const res = await getSalesAreaLetter()
      setSalesOrg(res.data.data)
    }

    getSalesOrg()
    role()
    getAllData()
    getAccessMenu()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  /** @deprecated gunakan onFetchFindoc */
  const getFindoc = async () => {
    setLoading(true)

    const res = await searchFindoc({...filter})

    setFindoc(res.data.data.data)
    dispath(setFinancialDocuments(res.data.data.data))
    setLoading(false)
    setNumberURL(res.data.data.links)
    dispath(setNumberUrl(res.data.data.links))
  }

  const onFetchFindoc = useCallback(() => {
    setLoading(true)
    setIsError(false)

    const role: any = localStorage.getItem('role-flag')
    const approval_flag = (hakAkses?.approve && role == 'finance') ? 2 : (hakAkses?.approve && role != 'finance' ? 1 : 0)

    searchFindoc({...filter, approval_flag})
      .then((res) => {
        setFindoc(res.data.data.data)
        setNumberURL(res.data.data.links)
      })
      .catch(() => setIsError(true))
      .finally(() => {
        setLoading(false)
        dispatch(setIsFetchData(false))
      })
  }, [filter])

  const paginateNumber = async (url: string) => {
    if (!url) return

    try {
      setLoading(true)

      const credentials = localStorage.getItem('credential')
      const token = localStorage.getItem('token')
      const role: any = localStorage.getItem('role-flag')
      const approval_flag = (hakAkses?.approve && role == 'finance') ? 2 : (hakAkses?.approve && role != 'finance' ? 1 : 0)
      const endpoint = `${url}&credentials=${credentials}&${objToParams({...filter, approval_flag})}`

      const res = await axios.get(endpoint, {
        headers: {...headers, Authorization: `Bearer ${token}`},
      })

      setFindoc(res.data.data.data)
      setNumberURL(res.data.data.links)
    } catch (error) {
      setIsError(true)
    } finally {
      setLoading(false)
    }
  }

  const goToDetail = (id: any) => {
    if (hakAkses?.read) {
      dispath(setGetNotif(!notif))
      sessionStorage.setItem('id', id)
      navigate('/financial/detail')
    }
  }

  const condTOP = (top: any) => {
    let trimmedTOP = ''
    if (top?.slice(1, 100) != undefined)
      trimmedTOP = 'Within ' + top?.slice(1, 100) + t(' days Due net')
    if (top == 'Z0LC') return 'Letter of Credit TOP'
    else if (top == 'Z000') return 'Payable immediately Due net'
    else if (top != 'Z0LC' && top != 'Z000') return trimmedTOP
  }

  useEffect(() => {
    const getData = setTimeout(() => onFetchFindoc(), 1000)
    return () => {
      clearTimeout(getData)
    }
  }, [onFetchFindoc])

  const handleReload = () => {
    dispatch(resetFilter())
    onFetchFindoc()
  }

  const setAsApproval = (findoc: any) => {
    const isLocOrSkbdn = ['skbdn', 'lc'].includes(findoc?.findoc_type)
    const role: any = localStorage.getItem('role-flag')
    const isFinance = role == 'finance'

    if ([1,3].includes(findoc?.status)) {
      if (isLocOrSkbdn && !isFinance && hakAkses?.approve) return true
      if (!isLocOrSkbdn && isFinance && hakAkses?.approve) return true
    } else if (findoc?.status == 4 && isFinance) return true

    return false
  }

  return (
    <StyledCard>
      {roleUser == 'null' ? (
        <>
          <ButtonGroups hasCreate={roleUser === 'null'} onResetFilter={handleReload} />

          <TableUI.TableWrapper>
            <TableUI.Table>
              <TableUI.THead>
                <RowHead />
              </TableUI.THead>
              <TableUI.TBody>
                <RowFilter />

                {loading ? (
                  <RowLoader />
                ) : isError ? (
                  <RowErrorFetch />
                ) : findoc.length === 0 ? (
                  <RowEmptyData />
                ) : (
                  findoc.map((item, _index) => (
                    <Fragment key={item.id ?? _index}>
                      <tr className={item.status === 2 ? 'bg-kuning' : ''}>
                        <td>
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '0.5rem',
                              width: '100%',
                            }}
                          >
                            <button
                              className='iconArow d-flex justify-content-center align-items-center me-2'
                              data-target={'target' + item['id']}
                              title={t(tooltip)}
                              onClick={(e: any) => {
                                handleOpen(e)
                              }}
                            ></button>
                            <span>{item['id']}</span>
                          </div>
                        </td>
                        <td>
                          <span
                            style={{fontSize: 13}}
                            className={`fw-semibold cursor-pointer badge ${
                              item.has_notif && item.status == 5
                                ? 'text-success'
                                : item.has_notif && item.status == 99
                                ? 'text-danger'
                                : 'text-primary'
                            }`}
                            onClick={() => {
                              goToDetail(item['id'])
                              handleNotif(item)
                            }}
                          >
                            {item.findoc_number}
                          </span>
                        </td>
                        <td>
                          <PopoverText
                            content={
                              item.customer?.title
                                ? item.customer?.title + ' ' + item.customer?.name
                                : item.customer?.name
                            }
                            index={_index}
                            className='spec-sliceee'
                          />
                        </td>
                        <td>
                          {item.sap_number == null ? (
                            <span>-</span>
                          ) : (
                            <span>{item.sap_number}</span>
                          )}
                        </td>
                        <td>
                          {item.created_at == null ? (
                            <span>-</span>
                          ) : (
                            <span>{dateformat(item.created_at)}</span>
                          )}
                        </td>
                        <td>{t(item.sales_organization?.name)}</td>
                        <td>{t(item.sector?.name)}</td>
                        <td>{dateformat(item.tgl_findoc)}</td>
                        <td>{item.num_findoc}</td>
                        <td>{item.findoc_type_detail?.name}</td>
                        <td>
                          {item['findoc_type'] === 'bg' || item['findoc_type'] === 'lc' ? (
                            <span>-</span>
                          ) : (
                            <>
                              {item.type_skbdn != null ? (
                                <span>
                                  {item['type_skbdn'] == '1' ? (
                                    <span className=''>At Sight</span>
                                  ) : (
                                    <span className=''>Usance</span>
                                  )}
                                </span>
                              ) : (
                                <span>-</span>
                              )}
                            </>
                          )}
                        </td>
                        <td>
                          {item.no_skpp === null ? (
                            <>
                              <span>-</span>
                            </>
                          ) : (
                            <>
                              <span>{item.no_skpp}</span>
                            </>
                          )}
                        </td>
                        <td>
                          {item['negara_desc'] == null ? (
                            <span>-</span>
                          ) : (
                            <span>{item['negara_desc']}</span>
                          )}
                        </td>
                        <td>
                          {item['currency'] == null ? (
                            <span>-</span>
                          ) : (
                            <span>{item['currency']}</span>
                          )}
                        </td>
                        <td>
                          {item['bank_name'] == null ? (
                            <span>-</span>
                          ) : (
                            <PopoverText
                              content={item['bank_name']}
                              index={_index}
                              className='spec-sliceee'
                            />
                          )}
                        </td>
                        <td>
                          {item.nilai == null ? (
                            <span>-</span>
                          ) : (
                            <span>
                              {/* {item.currency == 'IDR' ? 'Rp' : '$'} */}
                              {i18next.language === 'en'
                                ? item.nilai?.toLocaleString('en', {maximumFractionDigits: 4})
                                : item.nilai?.toLocaleString('id', {maximumFractionDigits: 4})}
                            </span>
                          )}
                        </td>
                        <td>
                          {item.allowance == null ? (
                            <span>-</span>
                          ) : (
                            <span>
                              {i18next.language === 'en'
                                ? item.allowance?.toLocaleString('en', {
                                    maximumFractionDigits: 4,
                                  })
                                : item.allowance?.toLocaleString('id', {
                                    maximumFractionDigits: 4,
                                  })}
                              %
                            </span>
                          )}
                        </td>
                        <td>
                          {item.resedual_value == 0 || item.resedual_value == null ? (
                            <span>-</span>
                          ) : (
                            <span>
                              {item.currency == 'IDR' ? 'Rp' : 'USD'}
                              {i18next.language === 'en'
                                ? item.resedual_value?.toLocaleString('en', {
                                    maximumFractionDigits: 4,
                                  })
                                : item.resedual_value?.toLocaleString('id', {
                                    maximumFractionDigits: 4,
                                  })}
                            </span>
                          )}
                        </td>
                        <td>
                          {item.top == null ? <span>-</span> : <span>{condTOP(item.top)}</span>}
                        </td>
                        <td>
                          <span>
                            {item.incoterm != null ? (
                              <>
                                {item.incoterm2_id == null
                                  ? item['incoterm']?.code
                                  : item['incoterm']?.code + '-' + item.incoterm2_id}
                              </>
                            ) : (
                              <span>-</span>
                            )}
                          </span>
                        </td>
                        <td>
                          {item.validity_date_from !== null ? (
                            <span>{dateformat(item.validity_date_from)}</span>
                          ) : (
                            <span>-</span>
                          )}
                        </td>
                        <td>
                          {item.validity_date_to !== null ? (
                            <span>{dateformat(item.validity_date_to)}</span>
                          ) : (
                            <span>-</span>
                          )}
                        </td>
                        <td>
                          {item.delivery_deadline != null ? (
                            <span>{dateformat(item.delivery_deadline)}</span>
                          ) : (
                            <span>-</span>
                          )}
                        </td>
                        <td>
                          {item.status_text == 'Expired' ? (
                            <span className='badge badge-light-danger'>
                              {t(item['status_text'])}
                            </span>
                          ) : item.status == 1 ? (
                            <span className='badge badge-light-primary'>{t(item.statusText)}</span>
                          ) : item.status == 2 ? (
                            <span className='badge badge-light-dark'>{t(item.statusText)}</span>
                          ) : item.status == 3 ? (
                            <span className='badge badge-light-primary'>{t(item.statusText)}</span>
                          ) : item.status == 4 ? (
                            <span className='badge badge-light-success'>{t(item.statusText)}</span>
                          ) : item.status == 5 ? (
                            <span className='badge badge-light-success'>{t(item.statusText)}</span>
                          ) : item.status == 6 ? (
                            <span className='badge badge-light-warning'>{t(item.statusText)}</span>
                          ) : item.status == 13 ? (
                            <span className='badge badge-light-primary'>Pending</span>
                          ) : item.status == 90 ? (
                            <span className='badge badge-light-danger'>{t(item.statusText)}</span>
                          ) : (
                            <span className='badge badge-light-danger'>{t(item.statusText)}</span>
                          )}
                        </td>
                        <td>
                          <div
                            className='d-flex p-0 justify-content-center'
                            style={{marginTop: '1px', marginBottom: '1.5px'}}
                          >
                            <button
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                              title='Detail'
                              hidden={hakAkses?.read ? false : true}
                              onClick={() => {
                                goToDetail(item['id'])
                                handleNotif(item)
                              }}
                            >
                              <KTSVG
                                path='/media/icons/duotune/file-text-fill.svg'
                                className='svg-icon-3'
                              />
                            </button>

                            <button
                              onClick={() => {
                                setIsLoadingModal(true)
                                setShowUpload(true)
                                ambilAttachment(item.id)
                                setIDItem(item.id)
                              }}
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                              title={t('order-lampiran')}
                            >
                              <KTSVG
                                path='/media/icons/duotune/archive-fill.svg'
                                className='svg-icon-3'
                              />
                            </button>

                            {item?.status == 2 || item?.status == 99 ? (
                              <button
                                onClick={() => {
                                  setShowReason(true)
                                  setReason(item.reason)
                                  setStatus(item.status)
                                }}
                                hidden={hakAkses?.read ? false : true}
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                title={t('notes')}
                              >
                                <KTSVG
                                  path='/media/icons/duotune/chat-left-text-fill.svg'
                                  className='svg-icon-3'
                                />
                              </button>
                            ) : (
                              <></>
                            )}
                          </div>
                        </td>
                      </tr>

                      <tr className='fold' id={'target' + item['id']}>
                        <TableUI.TableDetail colSpan={25}>
                          <TableUI.TableWrapper style={{marginBottom: 0}}>
                            <TableUI.Table>
                              <TableUI.THead>
                                <tr style={{backgroundColor: '#274070'}}>
                                  <th>{t('item number')}</th>
                                  <th>Sales Org</th>
                                  <th>Incoterm</th>
                                  <th>{t('kontrak-soNomor')}</th>
                                  <th>So {t('nomor')} SAP</th>
                                  <th>{t('kontrak-kuantum')} SO</th>
                                  <th>{t('kontrak-hargaPPN')}</th>
                                  <th>PPN</th>
                                  <th>{t('kontrak-hargaSPPN')}</th>
                                  <th>Status</th>
                                </tr>
                              </TableUI.THead>
                              <TableUI.TBody>
                                {item?.sales_orders?.length === 0 ? (
                                  <tr>
                                    <td colSpan={10}>
                                      <span className='badge badge-light-warning'>{t('empty data')}</span>
                                    </td>
                                  </tr>
                                ) : (
                                  item['sales_orders']?.map((subItem: any, index: number) => (
                                    <tr key={subItem?.id ?? index}>
                                      <td>{index + 1}</td>
                                      <td>{item.sales_organization?.name}</td>
                                      <td>
                                        {subItem.incoterm1?.code}
                                        {subItem.incoterm2 != null ? '-' + subItem.incoterm2 : ''}
                                      </td>
                                      <td>{subItem.so_number}</td>
                                      <td>{subItem.sap_number}</td>
                                      <td>
                                        {i18next.language === 'en'
                                          ? subItem.total_quantum_so.toLocaleString('en', {
                                              maximumFractionDigits: 4,
                                            })
                                          : subItem.total_quantum_so.toLocaleString('id', {
                                              maximumFractionDigits: 4,
                                            })}{' '}
                                        Ton
                                      </td>
                                      <td>
                                        {(subItem?.sector_id !== 3 ? 'Rp' : 'USD') +
                                          (i18next.language === 'en'
                                            ? subItem.price_before_ppn?.toLocaleString('en', {
                                                maximumFractionDigits: 4,
                                              })
                                            : subItem.price_before_ppn?.toLocaleString('id', {
                                                maximumFractionDigits: 4,
                                              }))}
                                      </td>
                                      <td>{subItem.ppn}%</td>
                                      <td>
                                        {(subItem?.sector_id !== 3 ? 'Rp' : 'USD') +
                                          (i18next.language === 'en'
                                            ? subItem.price_after_ppn?.toLocaleString('en', {
                                                maximumFractionDigits: 4,
                                              })
                                            : subItem.price_after_ppn?.toLocaleString('id', {
                                                maximumFractionDigits: 4,
                                              }))}
                                      </td>
                                      <td>
                                        {subItem.status_text == 'SAP ERROR'
                                          ? <span className='badge badge-light-raning'>{t(subItem.status_text)}</span>
                                          : <span className='badge badge-light-success'>{t(subItem.status_text)}</span>
                                        }
                                      </td>
                                    </tr>
                                  ))
                                )}
                              </TableUI.TBody>
                            </TableUI.Table>
                          </TableUI.TableWrapper>
                        </TableUI.TableDetail>
                      </tr>
                    </Fragment>
                  ))
                )}
              </TableUI.TBody>
            </TableUI.Table>
          </TableUI.TableWrapper>
        </>
      ) : (
        <>
          <ButtonGroups hasCreate={hakAkses?.create} hasExport={hakAkses?.export} onResetFilter={handleReload} />

          <TableUI.TableWrapper>
            <TableUI.Table>
              <TableUI.THead>
                <RowHead />
              </TableUI.THead>
              <TableUI.TBody>
                <RowFilter />

                {loading ? (
                  <RowLoader />
                ) : isError ? (
                  <RowErrorFetch />
                ) : findoc.length === 0 ? (
                  <RowEmptyData />
                ) : (
                  findoc.map((item, _index) => (
                    <Fragment key={item.id ?? _index}>
                      <tr
                        key={item.id ?? _index}
                        className={setAsApproval(item) ? 'bg-kuning' : ''}
                      >
                        <td>
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '0.5rem',
                              width: '100%',
                            }}
                          >
                            <button
                              className='iconArow d-flex justify-content-center align-items-center me-2'
                              data-target={'target' + item['id']}
                              title={t(tooltip)}
                              onClick={(e: any) => {
                                handleOpen(e)
                              }}
                            ></button>
                            <span>{item['id']}</span>
                          </div>
                        </td>
                        <td>
                          <span
                            className='fw-semibold cursor-pointer'
                            style={{color: '#274070'}}
                            onClick={() => goToDetail(item['id'])}
                          >
                            {item.findoc_number}
                          </span>
                        </td>
                        <td>
                          <PopoverText
                            content={
                              item.customer?.title
                                ? item.customer?.title + ' ' + item.customer?.name
                                : item.customer?.name
                            }
                            index={_index}
                            className='spec-slicee'
                          />
                        </td>
                        <td>
                          {item.sap_number == null || item.sap_number == '' ? (
                            <span>-</span>
                          ) : (
                            <span>{item.sap_number}</span>
                          )}
                        </td>
                        <td>
                          <span>{dateformat(item.created_at)}</span>
                        </td>
                        <td>
                          <span>{t(item.sales_organization?.name)}</span>
                        </td>
                        <td>
                          <span>{t(item.sector?.name)}</span>
                        </td>
                        <td>
                          <span>{dateformat(item.tgl_findoc)}</span>
                        </td>
                        <td>
                          <span>{item.num_findoc}</span>
                        </td>
                        <td>
                          <span>
                            {item['findoc_type'] === 'bg' ? (
                              <span>Bank Guarantee</span>
                            ) : item['findoc_type'] === 'lc' ? (
                              <span>Letter of Credit</span>
                            ) : item.findoc_type === 'skbdn' ? (
                              <span>SKBDN</span>
                            ) : (
                              <span>{item['findoc_type']}</span>
                            )}
                          </span>
                        </td>
                        <td>
                          {item['findoc_type'] === 'bg' || item['findoc_type'] === 'lc' ? (
                            <span>-</span>
                          ) : (
                            <span>
                              {item.type_skbdn != null ? (
                                <>
                                  {item['type_skbdn'] == '1' ? (
                                    <span className=''>At Sight</span>
                                  ) : (
                                    <span className=''>Usance</span>
                                  )}
                                </>
                              ) : (
                                '-'
                              )}
                            </span>
                          )}
                        </td>
                        <td>
                          <span>
                            {item['no_skpp'] == 'null' || item['no_skpp'] == null ? (
                              <span>-</span>
                            ) : (
                              item['no_skpp']
                            )}
                          </span>
                        </td>
                        <td>
                          {item['negara_desc'] != null ? (
                            <span>{item['negara_desc']}</span>
                          ) : (
                            <span>-</span>
                          )}
                        </td>
                        <td>
                          {item['currency'] != null ? (
                            <span>{item['currency']}</span>
                          ) : (
                            <span>-</span>
                          )}
                        </td>
                        <td>
                          {item['bank_name'] != null ? (
                            <PopoverText
                              content={item['bank_name']}
                              index={_index}
                              className='spec-slicee'
                            />
                          ) : (
                            <span>-</span>
                          )}
                        </td>
                        <td>
                          {item.nilai == null ? (
                            <span>-</span>
                          ) : (
                            <span>
                              {i18next.language === 'en'
                                ? item.nilai?.toLocaleString('en', {maximumFractionDigits: 4})
                                : item.nilai?.toLocaleString('id', {maximumFractionDigits: 4})}
                            </span>
                          )}
                        </td>
                        <td>
                          {item.allowance == null ? (
                            <span>-</span>
                          ) : (
                            <span>
                              {i18next.language === 'en'
                                ? item.allowance?.toLocaleString('en', {
                                    maximumFractionDigits: 4,
                                  })
                                : item.allowance?.toLocaleString('id', {
                                    maximumFractionDigits: 4,
                                  })}
                              %
                            </span>
                          )}
                        </td>
                        <td>
                          {item.resedual_value == 0 || item.resedual_value == null ? (
                            <span>-</span>
                          ) : (
                            <span>
                              {item.currency == 'IDR' ? 'Rp' : 'USD'}
                              {i18next.language === 'en'
                                ? item.resedual_value?.toLocaleString('en', {
                                    maximumFractionDigits: 4,
                                  })
                                : item.resedual_value?.toLocaleString('id', {
                                    maximumFractionDigits: 4,
                                  })}
                            </span>
                          )}
                        </td>
                        <td>
                          {item.top == null || item.top == 0 ? (
                            <span>-</span>
                          ) : (
                            <span>{condTOP(item.top)}</span>
                          )}
                        </td>
                        <td>
                          <span>
                            {item.incoterm != null ? (
                              <>
                                {item.incoterm2_id == null
                                  ? item['incoterm']?.code
                                  : item['incoterm']?.code + '-' + item.incoterm2_id}
                              </>
                            ) : (
                              <label className='opacity-0'>-</label>
                            )}
                          </span>
                        </td>
                        <td>
                          {item.validity_date_from == null ? (
                            <span>-</span>
                          ) : (
                            <span>{dateformat(item.validity_date_from)}</span>
                          )}
                        </td>
                        <td>
                          {item.validity_date_to == null ? (
                            <span>-</span>
                          ) : (
                            <span>{dateformat(item.validity_date_to)}</span>
                          )}
                        </td>
                        <td>
                          {item.delivery_deadline == null ? (
                            <span>-</span>
                          ) : (
                            <span>{dateformat(item.delivery_deadline)}</span>
                          )}
                        </td>
                        <td>
                          {item.status_text == 'Expired' ? (
                            <span className='badge badge-light-danger'>{t(item['status_text'])}</span>
                          ) : item.status == 1 ? (
                            <span className='badge badge-light-primary'>{t(item.statusText)}</span>
                          ) : item.status == 2 ? (
                            <span className='badge badge-light-warning'>{t(item.statusText)}</span>
                          ) : item.status == 3 ? (
                            <span className='badge badge-light-primary'>{t(item.statusText)}</span>
                          ) : item.status == 4 ? (
                            <span className='badge badge-light-success'>{t(item.statusText)}</span>
                          ) : item.status == 5 ? (
                            <span className='badge badge-light-success'>{t(item.statusText)}</span>
                          ) : item.status == 6 ? (
                            <span className='badge badge-light-success'>{t(item.statusText)}</span>
                          ) : item.status == 13 ? (
                            <span className='badge badge-light-primary'>{t(item.statusText)}</span>
                          ) : item.status == 90 ? (
                            <span className='badge badge-light-danger'>{t(item.statusText)}</span>
                          ) : (
                            <span className='badge badge-light-danger'>{t(item.statusText)}</span>
                          )}
                        </td>
                        <td>
                          <div
                            className='d-flex p-0 justify-content-center'
                            style={{marginTop: '1px', marginBottom: '1.5px'}}
                          >
                            <button
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                              title='Detail'
                              onClick={() => {
                                goToDetail(item['id'])
                              }}
                            >
                              <KTSVG
                                path='/media/icons/duotune/file-text-fill.svg'
                                className='svg-icon-3'
                              />
                            </button>

                            <button
                              onClick={() => {
                                setIsLoadingModal(true)
                                setShowUpload(true)
                                ambilAttachment(item.id)
                                setIDItem(item.id)
                              }}
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                              title={t('order-lampiran')}
                            >
                              <KTSVG
                                path='/media/icons/duotune/archive-fill.svg'
                                className='svg-icon-3'
                              />
                            </button>

                            {item?.status == 2 || item?.status == 99 ? (
                              <button
                                onClick={() => {
                                  setShowReason(true)
                                  setReason(item.reason)
                                  setStatus(item.status)
                                }}
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                title={t('alasan-tolak')}
                              >
                                <KTSVG
                                  path='/media/icons/duotune/chat-left-text-fill.svg'
                                  className='svg-icon-3'
                                />
                              </button>
                            ) : (
                              ''
                            )}

                            {item?.comment_finance != null ? (
                              <button
                                onClick={() => {
                                  setShowReason(true)
                                  setReason(item.comment_finance)
                                  setStatus(0)
                                }}
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                title={t('Comment_finance')}
                              >
                                <KTSVG
                                  path='/media/icons/duotune/card-heading.svg'
                                  className='svg-icon-3'
                                />
                              </button>
                            ) : (
                              ''
                            )}
                            {(roleUser == 'salesAnper' || roleUser == 'finance') &&
                              item.status == '13' && (
                                <button
                                  onClick={() => resendToSAP(item['id'])}
                                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                  title={t('sentSAP')}
                                >
                                  <i className='fas fa-sync-alt'></i>
                                </button>
                              )}
                          </div>
                        </td>
                      </tr>

                      <tr className='fold' id={'target' + item['id']}>
                        <TableUI.TableDetail colSpan={25}>
                          <TableUI.TableWrapper style={{marginBottom: 0}}>
                            <TableUI.Table>
                              <TableUI.THead>
                                <tr style={{backgroundColor: '#274070'}}>
                                  <th>{t('item number')}</th>
                                  <th>Sales Org</th>
                                  <th>Incoterm</th>
                                  <th>{t('kontrak-soNomor')}</th>
                                  <th>So {t('nomor')} SAP</th>
                                  <th>{t('kontrak-kuantum')} SO</th>
                                  <th>{t('kontrak-hargaPPN')}</th>
                                  <th>PPN</th>
                                  <th>{t('kontrak-hargaSPPN')}</th>
                                  <th>Status</th>
                                </tr>
                              </TableUI.THead>
                              <TableUI.TBody>
                                {item?.sales_orders?.length === 0 ? (
                                  <tr>
                                    <td colSpan={10}>
                                      <span className='badge badge-light-warning'>{t('empty data')}</span>
                                    </td>
                                  </tr>
                                ) : (
                                  item['sales_orders']?.map((subItem: any, index: number) => (
                                    <tr key={subItem?.id ?? index}>
                                      <td>{index + 1}</td>
                                      <td>{item.sales_organization?.name}</td>
                                      <td>
                                        {subItem.incoterm1?.code}
                                        {subItem.incoterm2 != null ? '-' + subItem.incoterm2 : ''}
                                      </td>
                                      <td>{subItem.so_number}</td>
                                      <td>{subItem.sap_number}</td>
                                      <td>
                                        {i18next.language === 'en'
                                          ? subItem.total_quantum_so.toLocaleString('en', {
                                              maximumFractionDigits: 4,
                                            })
                                          : subItem.total_quantum_so.toLocaleString('id', {
                                              maximumFractionDigits: 4,
                                            })}{' '}
                                        Ton
                                      </td>
                                      <td>
                                        {(subItem?.sector_id !== 3 ? 'Rp' : 'USD') +
                                          (i18next.language === 'en'
                                            ? subItem.price_before_ppn?.toLocaleString('en', {
                                                maximumFractionDigits: 4,
                                              })
                                            : subItem.price_before_ppn?.toLocaleString('id', {
                                                maximumFractionDigits: 4,
                                              }))}
                                      </td>
                                      <td>{subItem.ppn}%</td>
                                      <td>
                                        {(subItem?.sector_id !== 3 ? 'Rp' : 'USD') +
                                          (i18next.language === 'en'
                                            ? subItem.price_after_ppn?.toLocaleString('en', {
                                                maximumFractionDigits: 4,
                                              })
                                            : subItem.price_after_ppn?.toLocaleString('id', {
                                                maximumFractionDigits: 4,
                                              }))}
                                      </td>
                                      <td>
                                        {subItem.status_text == 'SAP ERROR'
                                          ? <span className='badge badge-light-wraning'>{t(subItem.status_text)}</span>
                                          : <span className='badge badge-light-success'>{t(subItem.status_text)}</span>
                                        }
                                      </td>
                                    </tr>
                                  ))
                                )}
                              </TableUI.TBody>
                            </TableUI.Table>
                          </TableUI.TableWrapper>
                        </TableUI.TableDetail>
                      </tr>
                    </Fragment>
                  ))
                )}
              </TableUI.TBody>
            </TableUI.Table>
          </TableUI.TableWrapper>
        </>
      )}

      <Modal
        size='lg'
        show={showUpload}
        onHide={() => setShowUpload(false)}
        backdrop='static'
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('order-fileBox')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {isLoadingModal ? (
            <Skeleton width={100} height={30} />
          ) : (
            <Row>
              <Col sm={6}>
                <table className='mb-3'>
                  <tr>
                    <td style={{width: '120px'}}>
                      <h6>{t('order-fileUnggah')}</h6>
                    </td>
                    <td className='w-75'>
                      <InputFile
                          setFileName={setNamaFile}
                          setFiles={setFiles}
                          isBase64={false}
                      />
                    </td>
                  </tr>
                </table>
                <table className='mb-3'>
                  <tr>
                    <td style={{width: '120px'}}>
                      <h6>{t('order-keterangan')}</h6>
                    </td>
                    <td className='w-75'>
                      <Form.Control
                        type='text'
                        placeholder={t('order-keterangan')}
                        id='uploadketerangan'
                        onChange={(e: any) => setDescription(e.target.value)}
                      />
                    </td>
                  </tr>
                </table>
                <table className='mb-3'>
                  <tr>
                    <td>
                      <h6 className='me-11'>{t('Private')}</h6>
                    </td>
                    <td className='w-75 d-flex justify-content-start'>
                      <Form.Check
                        reverse
                        name='isPrivate'
                        type='checkbox'
                        className='mt-5 mb-2'
                        onClick={() => {
                          setIsPrivate(!isPrivate)
                        }}
                        id='isPrivate'
                      />
                    </td>
                  </tr>
                </table>
                <Button
                  variant='primary'
                  className='w-100'
                  disabled={btnLoading}
                  onClick={() => handleUpload(idItem)}
                >
                  {btnLoading ? (
                    <Spinner animation='border' variant='light' size='sm' />
                  ) : (
                    t('order-kirim')
                  )}
                </Button>
              </Col>
              <div className='table-responsive mt-4' style={{marginTop: '3rem'}}>
                <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                  <thead className='border-bottom'>
                    <tr className=''>
                      <th className='text-center'>{t('order-noo')}</th>
                      <th className='text-center'>{t('order-keterangan')}</th>
                      <th className='text-center'>{t('order-tglUpload')}</th>
                      {/* <th className='text-center'>{t('User Code')}</th> */}
                      <th className='text-center'>{t('order-user')}</th>
                      <th className='text-center'>{t('order-aksi')}</th>
                    </tr>
                  </thead>
                  {allFile.map((data: any, _index: number) => (
                    <tbody key={data?.id ?? _index}>
                      <tr className=''>
                        <td className='text-center'>
                          <label>{_index + 1}</label>
                        </td>
                        <td className='text-center'>
                          <label>{data.description}</label>
                        </td>
                        <td className='text-center'>
                          <label>{dateformat(data.updated_at)}</label>
                        </td>
                        {/* <td className='text-center'>
                          <label>{data.user?.customer_code || data.user?.nama_pengguna}</label>
                        </td> */}
                        <td className='text-center'>
                          {data.user?.customer != null ? (
                            <label>
                              <PopoverText
                                content={data.user?.customer?.name}
                                index={_index}
                                className='spec-slice'
                              />
                            </label>
                          ) : (
                            <label>
                              <PopoverText
                                content={data.user?.name}
                                index={_index}
                                className='spec-slice'
                              />
                            </label>
                          )}
                        </td>
                        <td className='text-center'>
                          <button
                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                            data-bs-toggle='tooltip'
                            data-bs-placement='top'
                            data-bs-trigger='hover'
                            title={t('unduh')}
                            onClick={() =>
                              handleDownloadAttachment(
                                data.file_path
                              )
                            }
                          >
                            <KTSVG
                              path='/media/icons/duotune/arrow-down-square-fill.svg'
                              className='svg-icon-3'
                            />
                          </button>
                          {(hakAkses?.attachment_delete ||
                            CheckSameIDAttachment(data.user_role_flag)) && (
                            <button
                              onClick={() => deleteAttachment(data.id)}
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                              data-bs-toggle='tooltip'
                              data-bs-placement='top'
                              data-bs-trigger='hover'
                              title={t('Hapus')}
                              hidden={
                                roleUser != 'finance' && roleUser != 'salesAnper' ? true : false
                              }
                            >
                              <KTSVG
                                path='/media/icons/duotune/trash-fill.svg'
                                className='svg-icon-3'
                              />
                            </button>
                          )}
                        </td>
                      </tr>
                    </tbody>
                  ))}
                </table>
              </div>
            </Row>
          )}
        </Modal.Body>
      </Modal>

      <Modal
        size='lg'
        show={showReason}
        onHide={() => setShowReason(false)}
        backdrop='static'
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          {status == 2 ? (
            <Modal.Title>{t('Revision')}</Modal.Title>
          ) : status == 99 ? (
            <Modal.Title>{t('order-tolak')}</Modal.Title>
          ) : (
            <Modal.Title>Finance Comment</Modal.Title>
          )}
        </Modal.Header>
        <Modal.Body>
          {isLoadingModal ? (
            <Skeleton width={100} height={30} />
          ) : (
            <div className='d-flex justify-content-center'>
              {/* <span className='text-bold'>{reason}</span> */}
              <PopoverText content={reason} index={0} className='spec-slice' />
            </div>
          )}
        </Modal.Body>
      </Modal>

      <Pagination paginate={paginateNumber} test={numberURL} />
    </StyledCard>
  )
}

export {TableFinancial}
